import './_style.scss';

import React from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap';

const ModalProtocoloExcluidoSucesso = ({ isOpen, toggle }) => {  
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal_md">
    <ModalHeader toggle={toggle} />
    <ModalBody>
      Protocolo excluído com sucesso. 
{' '}
<br />
    </ModalBody>
    <ModalFooter>
      <Button className="btn_success" onClick={toggle}>Fechar</Button>
    </ModalFooter>
  </Modal>
  );
}

export default ModalProtocoloExcluidoSucesso;
